/**
 * World of Oshar — images served from `public/images/world/oshar/`
 * (copies of `src/assets/.../World/` ChatGPT exports, simple filenames for reliable URLs).
 */
const base = `${process.env.PUBLIC_URL || ""}/images/world/oshar`;

const u = (name) => `${base}/${name}`;

export const OSH_IMAGES = {
  hero: u("oshar-hero.png"),
  introPanorama: u("oshar-panorama.png"),
  featureLiveEvents: u("oshar-live-events.png"),
  featureColiseum: u("oshar-coliseum.png"),
  featureCasino: u("oshar-casino.png"),
  featureShopping: u("oshar-shopping.png"),
  featureVrRealEstate: u("oshar-waterfront.png"),
  featureConnected: u("oshar-connected.png"),
  districtWaterfront: u("oshar-panorama.png"),
  districtColiseum: u("oshar-coliseum.png"),
  districtCasino: u("oshar-casino.png"),
  districtMarket: u("oshar-shopping.png"),
  ctaRealEstate: u("oshar-terrace-cta.png"),
};
